module.exports = __webpack_public_path__ + "static/media/cokebanner.d6294abc.svg";